export default function LegalFooter(){return <nav className="tl-legal-links" aria-label="Legal information"><a href="/terms">Terms of use</a><a href="/privacy">Privacy notice</a><a href="/pricing">Pricing</a></nav>;}
